<template>
  <div class="app-container" v-show="isLogin">
    <!-- 佣金列表 -->
    <el-table

      v-loading="listLoading"
      :data="yongjinList"
      highlight-current-row
      style="color: rgb(70, 70, 70); margin-top: 10px"
      :row-style="{ height: '0' }"
      :cell-style="{ padding: '3px 0' }"
      :header-cell-style="{
        background: 'rgb(247 248 252) !important',
        color: '#ededed  !important',
        padding: '7px 0',
        color: 'rgb(140, 140, 140)',
      }"
    >
      <el-table-column label="来源用户" align="left" min-width="1">
        <template slot-scope="{ row }">
          <span v-if="row.upperuser != '' || row.upperuser != null">{{ row.name }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="仓库" min-width="3" align="left">
        <template slot-scope="{ row }">
          <span
            class="ellipsis"
            :title="row.pingtai"
            v-if="row.pingtai != '' || row.pingtai != null"
            >{{ row.pingtai.desc_name }}</span
          >
        </template>
      </el-table-column> -->
      <el-table-column label="佣金来源" min-width="2" align="left">
        <template slot-scope="{ row }">
          <span>{{ row.remarks }} , 订单号：{{ row.order_no }}</span>
        </template>
      </el-table-column>
      <el-table-column label="佣金金额" min-width="1" align="left">
        <template slot-scope="{ row }">
          <span>{{ row.amount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="佣金状态" min-width="1" align="left">
        <template slot-scope="{ row }">
          <span>{{ row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column label="下单时间" min-width="1" align="left">
        <template slot-scope="{ row }">
          <span class="ellipsis" :title="row.updated_at">{{ row.ordered_at }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="yongjinTotal > 0"
      :total="yongjinTotal"
      :page.sync="listQuery.page"
      layout="total, prev, pager, next"
      style="padding-top: 12px; padding-bottom: 0px; text-align: center"
      @pagination="getCommissionList()"
    />
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination

export default {
  name: "dltg",
  components: {
    Pagination,
  },
  filters: {
    handleFilter(status) {
      const handleMap = {
        1: "己成功返款给上家用户",
        0: "没有计算 ",
      };
      return handleMap[status];
    },
  },
  data() {
    return {
      isLogin: false,
      yongjinList: [],
      yongjinTotal: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        per_page: 15,
        // button: 1,
        status: 0,
      },
      isShow: true,
    };
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");

    if (userToken == undefined) {
      this.isLogin = false;
      this.$confirm("请先登录再使用！", "提示", {
        confirmButtonText: "确定",
      })
        .then(() => {
          // 重新导航到登录页面
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/login" });
        })
        .catch(() => {
          // 重新导航到首页
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/" });
        });
      return;
    } else {
      this.isLogin = true;
    }
    // this.getList(2);
    this.getCommissionList();
  },
  methods: {
    getCommissionList() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
      }
      const url = this.$root.commonPreUrl + "/index/commissionList";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: this.listQuery,
      });
      res.then((response) => {
        const resd = response.data;
        if (resd.code == 200) {
          this.yongjinList = resd.data.data;
          this.yongjinTotal = resd.data.total;
        }
      });
      res.catch((error) => {
        console.error("初始请求失败:", error);
      });
      res.finally(() => {
        this.listLoading = false;
      });
    },
    getList(btn) {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            Cookies.set("view_historyPath", "/dltg", { expires: 1 });
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.listQuery.button = btn;

      this.yongjinList = [];
      this.listLoading = true;
      const url = this.$root.commonPreUrl + "/index/kami";
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + userToken,
        },
        params: this.listQuery,
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            if (btn == 2) {
              this.yongjinList = resd.data.data;
              this.yongjinTotal = resd.data.total;
            }
            this.listLoading = false;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }
          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 3 * 1000);
    },
  },
};
</script>

<style>
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  max-width: 87%;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/dltg/yjlb/index.vue